import { useSelector } from 'react-redux'

import { client } from 'config/routes'
import { useAuth } from 'routes/Menu/domains/auth'
import { getIsBuildYourBoxCtaEnabled } from 'selectors/features'

import { CtaTexts } from './data'

/**
 * Used to get cta text & uri based on condition
 * if user logged in or not
 */

export const useGetCtaProps = ({ withDiscount = false }: { withDiscount?: boolean } = {}) => {
  const { isAuthenticated } = useAuth()
  const isBuildYourBoxCtaEnabled = useSelector(getIsBuildYourBoxCtaEnabled)

  const { menu, signup } = client

  const dynamicCtaText = () => {
    if (isBuildYourBoxCtaEnabled && withDiscount) {
      return CtaTexts.BUILD_BOX_WITH_DISCOUNT
    }
    if (isBuildYourBoxCtaEnabled && !withDiscount) {
      return CtaTexts.BUILD_BOX
    }
    if (!isBuildYourBoxCtaEnabled && withDiscount) {
      return CtaTexts.GET_STARTED_WITH_DISCOUNT
    }

    return CtaTexts.GET_STARTED
  }

  const ctaText = dynamicCtaText()

  if (!isAuthenticated) {
    return {
      ctaUri: signup,
      ctaText,
    }
  }

  return {
    ctaUri: menu,
    ctaText: CtaTexts.OPEN_MENU,
  }
}
